import { styled } from "styled-components";

export const ReviewButtonWrapper = styled.div`
  display: flex;
  align-items: end;
`;
